var map = {
	"./Candidates": [
		1664,
		841,
		664
	],
	"./Candidates/": [
		1664,
		841,
		664
	],
	"./Candidates/index": [
		1664,
		841,
		664
	],
	"./Candidates/index.js": [
		1664,
		841,
		664
	],
	"./DevPage": [
		2125,
		125
	],
	"./DevPage/": [
		2125,
		125
	],
	"./DevPage/index": [
		2125,
		125
	],
	"./DevPage/index.js": [
		2125,
		125
	],
	"./Sample": [
		5999,
		999
	],
	"./Sample/": [
		5999,
		999
	],
	"./Sample/index": [
		5999,
		999
	],
	"./Sample/index.js": [
		5999,
		999
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7659;
module.exports = webpackAsyncContext;